import { render, staticRenderFns } from "./Ciclos.vue?vue&type=template&id=005240b9&"
import script from "./Ciclos.vue?vue&type=script&lang=js&"
export * from "./Ciclos.vue?vue&type=script&lang=js&"
import style0 from "./Ciclos.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports